@if (this.selectedTab === 0) {
  <form [formGroup]="accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de standaarden op basis waarvan de jaarrekening is opgesteld</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.get('selected')?.getRawValue() === false"
          icon="{{ this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(1)">
          {{ this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="noChangesInAccountingPoliciesDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van herzieningen ten opzichte van voorgaand jaar</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.noChangesInAccountingPoliciesDescriptionFg.get('selected')?.getRawValue() === false"
          icon="{{ this.noChangesInAccountingPoliciesDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(2)">
          {{ this.noChangesInAccountingPoliciesDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.noChangesInAccountingPoliciesDescriptionFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="differenceFiscalCommercialAccountingPrinciplesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Verschillen tussen de waardering volgens fiscale en commerciële grondslagen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.get('selected')?.getRawValue() === false"
          icon="{{ this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(3)">
          {{ this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="accountingStandardsAppliedEarlierDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de standaarden die eerder werden toegepast</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.accountingStandardsAppliedEarlierDescriptionFg.get('selected')?.getRawValue() === false"
          icon="{{ this.accountingStandardsAppliedEarlierDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(4)">
          {{ this.accountingStandardsAppliedEarlierDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.accountingStandardsAppliedEarlierDescriptionFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over de actuele waarde bij toepassing van de historische
        prijsgrondslag</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.get('selected')?.getRawValue() === false"
          icon="{{ this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(5)">
          {{ this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over de historische kosten bij toepassing van de actuele waarde
        als grondslag</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.get('selected')?.getRawValue() === false"
          icon="{{ this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(6)">
          {{ this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="determinationCostPriceIndirectCostsDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de mate waarin bij de bepaling van de vervaardigingsprijs rekening is
        gehouden met indirecte kosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.determinationCostPriceIndirectCostsDescriptionFg.get('selected')?.getRawValue() === false"
          icon="{{ this.determinationCostPriceIndirectCostsDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(7)">
          {{ this.determinationCostPriceIndirectCostsDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.determinationCostPriceIndirectCostsDescriptionFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="functionalCurrencyDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de functionele valuta</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.functionalCurrencyDescriptionFg.get('selected')?.getRawValue() === false"
          icon="{{ this.functionalCurrencyDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(8)">
          {{ this.functionalCurrencyDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.functionalCurrencyDescriptionFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="relatedPartyTransactionsPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van transacties met verbonden partijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.relatedPartyTransactionsPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.relatedPartyTransactionsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(9)">
          {{ this.relatedPartyTransactionsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (!this.relatedPartyTransactionsPolicyFg.get('selected')?.getRawValue() === null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (this.selectedTab === 1) {
  <form [formGroup]="changeAccountingEstimatesExplanationFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Toelichting op de aard en de kwantitatieve effecten van een schattingswijziging indien
        deze van belang is voor de verslagperiode of toekomstige perioden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.changeAccountingEstimatesExplanationFg.get('selected')?.getRawValue() === false"
          icon="{{ this.changeAccountingEstimatesExplanationFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(20)">
          {{ this.changeAccountingEstimatesExplanationFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.changeAccountingEstimatesExplanationFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (this.selectedTab === 2) {
  <form [formGroup]="changeAccountingPoliciesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over stelselwijzigingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.changeAccountingPoliciesDisclosureFg.get('selected')?.getRawValue() === false"
          icon="{{ this.changeAccountingPoliciesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(30)">
          {{ this.changeAccountingPoliciesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.changeAccountingPoliciesDisclosureFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (this.selectedTab === 3) {
  <form [formGroup]="foreignCurrencyTranslationPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van omrekening van in vreemde valuta luidende bedragen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.foreignCurrencyTranslationPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.foreignCurrencyTranslationPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(40)">
          {{ this.foreignCurrencyTranslationPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.foreignCurrencyTranslationPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="foreignCurrencyTranslationBalanceSheetPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van de wijze van verwerking van valutakoersverschillen met betrekking tot
        transacties in vreemde valuta voor de balans</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.foreignCurrencyTranslationBalanceSheetPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.foreignCurrencyTranslationBalanceSheetPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(41)">
          {{ this.foreignCurrencyTranslationBalanceSheetPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.foreignCurrencyTranslationBalanceSheetPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (this.selectedTab === 4) {
  <form [formGroup]="leasesPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van leases</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.leasesPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.leasesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(50)">
          {{ this.leasesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.leasesPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="financeLeasesPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van financiële leases</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.financeLeasesPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.financeLeasesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(51)">
          {{ this.financeLeasesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.financeLeasesPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="operatingLeasesPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van operationele leases</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.operatingLeasesPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.operatingLeasesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(52)">
          {{ this.operatingLeasesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.operatingLeasesPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (selectedTab === 5) {
  <form [formGroup]="exceptionalItemsPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van bijzondere posten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.exceptionalItemsPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.exceptionalItemsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(60)">
          {{ this.exceptionalItemsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.exceptionalItemsPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="pensionArrangementsPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van pensioenregelingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.pensionArrangementsPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.pensionArrangementsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(61)">
          {{ this.pensionArrangementsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.pensionArrangementsPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="priorPeriodErrorsDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over foutherstel</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.priorPeriodErrorsDisclosureFg.get('selected')?.getRawValue() === false"
          icon="{{ this.priorPeriodErrorsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(62)">
          {{ this.priorPeriodErrorsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.priorPeriodErrorsDisclosureFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
  <form [formGroup]="shareBasedPaymentsPolicyFg">
    @if (heeftAandelen && !isCooperatie) {
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Grondslag van op aandelen gebaseerde betalingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
            [disabled]="this.shareBasedPaymentsPolicyFg.get('selected')?.getRawValue() === false"
            icon="{{ this.shareBasedPaymentsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
            class="custom-input-150"
            (click)="this.showDialog(63)">
            {{ this.shareBasedPaymentsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          @if (this.shareBasedPaymentsPolicyFg.get('selected')?.getRawValue() !== null) {
            <snelstart-ui-select-form-control formControlName="selected"
              [options]="this.optionsJaNee"
              class="custom-input-150"
              (change)="this.saveForm()"
              >
            </snelstart-ui-select-form-control>
          }
        </div>
      </div>
    }
  </form>
  <form [formGroup]="financialInstrumentsPolicyFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Grondslag van financiële instrumenten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
          [disabled]="this.financialInstrumentsPolicyFg.get('selected')?.getRawValue() === false"
          icon="{{ this.financialInstrumentsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
          class="custom-input-150"
          (click)="this.showDialog(64)">
          {{ this.financialInstrumentsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        @if (this.financialInstrumentsPolicyFg.get('selected')?.getRawValue() !== null) {
          <snelstart-ui-select-form-control formControlName="selected"
            [options]="this.optionsJaNee"
            class="custom-input-150"
            (change)="this.saveForm()"
            >
          </snelstart-ui-select-form-control>
        }
      </div>
    </div>
  </form>
}

@if (this.index === 1) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg"
      [policyId]="'accountingStandardsUsedToPrepareFinancialStatementsDescription'"
      [title]="'Beschrijving van de standaarden op basis waarvan de jaarrekening is opgesteld'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 2) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.noChangesInAccountingPoliciesDescriptionFg"
      [policyId]="'noChangesInAccountingPoliciesDescription'"
      [title]="'Beschrijving van herzieningen ten opzichte van voorgaand jaar'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 3) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg"
      [policyId]="'differenceFiscalCommercialAccountingPrinciplesDisclosure'"
      [title]="'Verschillen tussen de waardering volgens fiscale en commerciële grondslagen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 4) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.accountingStandardsAppliedEarlierDescriptionFg"
      [policyId]="'accountingStandardsAppliedEarlierDescription'"
      [title]="'Beschrijving van de standaarden die eerder werden toegepast'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 5) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg"
      [policyId]="'fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosure'"
      [title]="'Informatieverschaffing over de actuele waarde bij toepassing van de historische prijsgrondslag'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 6) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg"
      [policyId]="'historicalCostInformationWhenPreparedOnFairValueBasisDisclosure'"
      [title]="'Informatieverschaffing over de historische kosten bij toepassing van de actuele waarde als grondslag'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 7) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.determinationCostPriceIndirectCostsDescriptionFg"
      [policyId]="'determinationCostPriceIndirectCostsDescription'"
      [title]="'Beschrijving van de mate waarin bij de bepaling van de vervaardigingsprijs rekening is gehouden met indirecte kosten'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 8) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.functionalCurrencyDescriptionFg"
      [policyId]="'functionalCurrencyDescription'"
      [title]="'Beschrijving van de functionele valuta'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 9) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.relatedPartyTransactionsPolicyFg"
      [policyId]="'relatedPartyTransactionsPolicy'"
      [title]="'Grondslag van transacties met verbonden partijen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 20) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.changeAccountingEstimatesExplanationFg"
      [policyId]="'changeAccountingEstimatesExplanation'"
      [title]="'Toelichting op de aard en de kwantitatieve effecten van een schattingswijziging indien deze van belang is voor de verslagperiode of toekomstige perioden'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 30) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.changeAccountingPoliciesDisclosureFg"
      [policyId]="'changeAccountingPoliciesDisclosure'"
      [title]="'Informatieverschaffing over stelselwijzigingen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}

@if (this.index === 40) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.foreignCurrencyTranslationPolicyFg"
      [policyId]="'foreignCurrencyTranslationPolicy'"
      [title]="'Grondslag van omrekening van in vreemde valuta luidende bedragen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 41) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.foreignCurrencyTranslationBalanceSheetPolicyFg"
      [policyId]="'foreignCurrencyTranslationBalanceSheetPolicy'"
      [title]="'Grondslag van de wijze van verwerking van valutakoersverschillen met betrekking tot transacties in vreemde valuta voor de balans'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 50) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.leasesPolicyFg"
      [policyId]="'leasesPolicy'"
      [title]="'Grondslag van leases'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 51) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.financeLeasesPolicyFg"
      [policyId]="'financeLeasesPolicy'"
      [title]="'Grondslag van financiële leases'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 52) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.operatingLeasesPolicyFg"
      [policyId]="'operatingLeasesPolicy'"
      [title]="'Grondslag van operationele leases'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 60) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.exceptionalItemsPolicyFg"
      [policyId]="'exceptionalItemsPolicy'"
      [title]="'Grondslag van bijzondere posten'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 61) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.pensionArrangementsPolicyFg"
      [policyId]="'pensionArrangementsPolicy'"
      [title]="'Grondslag van pensioenregelingen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 62) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.priorPeriodErrorsDisclosureFg"
      [policyId]="'priorPeriodErrorsDisclosure'"
      [title]="'Informatieverschaffing over foutherstel'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 63) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.shareBasedPaymentsPolicyFg"
      [policyId]="'shareBasedPaymentsPolicy'"
      [title]="'Grondslag van op aandelen gebaseerde betalingen'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
@if (this.index === 64) {
  <div>
    <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
      [(input)]="this.financialInstrumentsPolicyFg"
      [policyId]="'financialInstrumentsPolicy'"
      [title]="'Grondslag van financiële instrumenten'"
    (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
  </div>
}
